// SHADOW MARKET™ — i18n strings (ES/EN/SK).
// Imported via useShopI18n(lang) below; matches the project's existing
// per-feature i18n pattern (see simulator.js / shadow.js).

const ES = {
  back_home: "Volver a REBELBTC",
  eyebrow: "SHADOW MARKET™",
  tagline: "COLECCIONES INTERNAS — EDICIÓN LIMITADA",
  drop_active: "● DROP ACTIVO — VOL.01",

  under_construction_title: "Tienda en construcción",
  under_construction_body:
    "Estamos finalizando los últimos detalles de logística y fotografía de producto. Las imágenes son provisionales. Los pedidos abrirán muy pronto — el sistema de pago ya está conectado para el lanzamiento.",

  stat_polo: "POLO",
  stat_pantalon: "PANTALÓN",
  stat_camiseta: "CAMISETA",
  stat_pro: "PRO",

  tab_all: "TODOS",
  tab_polo: "POLOS",
  tab_pantalon: "PANTALONES",
  tab_camiseta: "CAMISETAS",

  card_size_label: "Talla",
  card_add: "AÑADIR",
  card_added: "AÑADIDO",
  card_quick_add: "AÑADIR AL CARRITO",
  card_pro_label: "PRO",
  card_pro_hint: (price) => `€${price.toFixed(2)} PRO`,
  card_no_products: "Sin productos en esta categoría.",
  rbl_badge_discount: "-25% con R₿L",

  pro_upsell_eyebrow: "¿ERES PRO?",
  pro_upsell_title_1: "Descuento",
  pro_upsell_title_2: "automático en todos los productos",
  pro_upsell_cta: "ACTIVAR PRO",

  open_cart: "Ver carrito",

  // Cart
  cart_title: "TU CARRITO",
  cart_empty: "Tu carrito está vacío",
  cart_empty_cta: "VER LA TIENDA",
  cart_subtotal: "Subtotal",
  cart_discount: "Descuento PRO (-15%)",
  cart_shipping: "Envío",
  cart_free: "GRATIS",
  cart_total: "TOTAL",
  cart_add_for_free_shipping: (delta) =>
    `Añade €${delta.toFixed(2)} más para envío gratis`,
  cart_checkout: "PROCEDER AL PAGO",
  cart_checkout_with_total: (total) => `PROCEDER AL PAGO — €${total.toFixed(2)}`,
  cart_redirecting: "REDIRIGIENDO…",
  cart_secure: "PAGO SEGURO · STRIPE · IVA INCLUIDO",
  cart_continue: "Seguir comprando",
  cart_summary: "RESUMEN",

  // Product page
  product_more_variants: "MÁS VARIANTES",
  product_color: "Color",
  product_size: "Talla",
  product_size_guide: "GUÍA DE TALLAS",
  product_quantity: "Cantidad",
  product_add: "AÑADIR AL CARRITO",
  product_added: "AÑADIDO",
  product_activate_pro: "Activa PRO para -15% →",
  product_pro_price: "PRO PRICE",
  product_not_found: "PRODUCTO NO ENCONTRADO",
  product_back_store: "← VOLVER A LA TIENDA",
  acc_details: "MATERIALES Y DETALLES",
  acc_shipping: "ENVÍO Y DEVOLUCIONES",
  acc_care: "CUIDADO",
  shipping_std: (cost) => `Estándar 3-7 días: €${cost.toFixed(2)}`,
  shipping_free_text: (min) => `Gratis en pedidos de +€${min.toFixed(0)}`,
  shipping_returns: "Devoluciones: 14 días",
  shipping_contact: "Contacto: rebelbtc@rebelbtc.com",
  care_body: "Lavar a 30° · No secar en secadora · No planchar el logo",
  size_guide_title: "GUÍA DE TALLAS",
  size_guide_col_size: "Talla",
  size_guide_col_chest: "Pecho (cm)",
  size_guide_col_length: "Largo (cm)",
  size_guide_col_waist: "Cintura (cm)",
  size_guide_disclaimer: "Medidas indicativas. Tolerancia ±1.5cm.",

  // Confirm
  confirm_title: "¡PEDIDO CONFIRMADO!",
  confirm_sub: "Recibirás un email de confirmación en breve.",
  confirm_syncing: "Sincronizando con Stripe…",
  confirm_order_no: "Nº PEDIDO",
  confirm_status: "Estado",
  confirm_paid: "✓ PAGADO",
  confirm_processing: "⏳ PROCESANDO",
  confirm_continue: "SEGUIR COMPRANDO",
  confirm_to_academy: "IR A LA ACADEMIA",

  // Type singular labels
  type_polo: "POLO",
  type_pantalon: "PANTALÓN",
  type_camiseta: "CAMISETA",
  type_polo_plural: "POLOS",
  type_pantalon_plural: "PANTALONES",
  type_camiseta_plural: "CAMISETAS",

  // Navbar
  nav_shop: "Tienda",

  // 3D Customization Studio
  customize_cta: "PERSONALIZAR EN 3D",
  customize_eyebrow: "ESTUDIO 3D",
  customize_title: "Diseña tu pieza única",
  customize_sub: "Rota, aplica color, sube tu logo o pon tu nombre. La personalización añade",
  customize_surcharge_label: "Personalización +€15",
  customize_back: "Volver al producto",
  customize_section_color: "COLOR DE LA PRENDA",
  customize_section_text: "TEXTO",
  customize_section_text_placeholder: "Tu texto (ej. REBEL)",
  customize_section_text_color: "COLOR DEL TEXTO",
  customize_section_image: "LOGO O IMAGEN",
  customize_section_image_btn: "SUBIR IMAGEN",
  customize_section_image_clear: "Quitar imagen",
  customize_section_image_hint: "PNG / JPG · máx 5 MB",
  customize_section_size: "TALLA",
  customize_section_preview: "VISTA PREVIA",
  customize_capture_btn: "GENERAR VISTA PREVIA",
  customize_loading: "Cargando modelo 3D…",
  customize_rotate_hint: "Arrastra para rotar · Rueda para zoom",
  customize_add_to_cart: "AÑADIR PERSONALIZADO AL CARRITO",
  customize_added: "PERSONALIZADO AÑADIDO",
  customize_select_size_first: "Selecciona una talla primero",
  customize_total_label: "Total con personalización",
  customize_only_available: "Solo disponible para polos y camisetas",

  // Cart customization line
  cart_customized: "PERSONALIZADO",
  cart_customization_extra: "Personalización +€15",
};

const EN = {
  back_home: "Back to REBELBTC",
  eyebrow: "SHADOW MARKET™",
  tagline: "INTERNAL DROPS — LIMITED EDITION",
  drop_active: "● DROP LIVE — VOL.01",

  under_construction_title: "Store under construction",
  under_construction_body:
    "We are finalizing logistics and product photography. Visuals are placeholders. Orders open very soon — the payment system is already wired for launch.",

  stat_polo: "POLO",
  stat_pantalon: "PANTS",
  stat_camiseta: "TEE",
  stat_pro: "PRO",

  tab_all: "ALL",
  tab_polo: "POLOS",
  tab_pantalon: "PANTS",
  tab_camiseta: "TEES",

  card_size_label: "Size",
  card_add: "ADD",
  card_added: "ADDED",
  card_quick_add: "ADD TO CART",
  card_pro_label: "PRO",
  card_pro_hint: (price) => `€${price.toFixed(2)} PRO`,
  card_no_products: "No products in this category.",
  rbl_badge_discount: "-25% with R₿L",

  pro_upsell_eyebrow: "ARE YOU PRO?",
  pro_upsell_title_1: "Automatic",
  pro_upsell_title_2: "discount on every product",
  pro_upsell_cta: "ACTIVATE PRO",

  open_cart: "Open cart",

  cart_title: "YOUR CART",
  cart_empty: "Your cart is empty",
  cart_empty_cta: "BROWSE THE STORE",
  cart_subtotal: "Subtotal",
  cart_discount: "PRO Discount (-15%)",
  cart_shipping: "Shipping",
  cart_free: "FREE",
  cart_total: "TOTAL",
  cart_add_for_free_shipping: (delta) =>
    `Add €${delta.toFixed(2)} more for free shipping`,
  cart_checkout: "PROCEED TO CHECKOUT",
  cart_checkout_with_total: (total) =>
    `PROCEED TO CHECKOUT — €${total.toFixed(2)}`,
  cart_redirecting: "REDIRECTING…",
  cart_secure: "SECURE PAYMENT · STRIPE · TAX INCLUDED",
  cart_continue: "Continue shopping",
  cart_summary: "SUMMARY",

  product_more_variants: "MORE VARIANTS",
  product_color: "Color",
  product_size: "Size",
  product_size_guide: "SIZE GUIDE",
  product_quantity: "Qty",
  product_add: "ADD TO CART",
  product_added: "ADDED",
  product_activate_pro: "Activate PRO for -15% →",
  product_pro_price: "PRO PRICE",
  product_not_found: "PRODUCT NOT FOUND",
  product_back_store: "← BACK TO STORE",
  acc_details: "MATERIALS & DETAILS",
  acc_shipping: "SHIPPING & RETURNS",
  acc_care: "CARE",
  shipping_std: (cost) => `Standard 3-7 days: €${cost.toFixed(2)}`,
  shipping_free_text: (min) => `Free on orders over €${min.toFixed(0)}`,
  shipping_returns: "Returns: 14 days",
  shipping_contact: "Contact: rebelbtc@rebelbtc.com",
  care_body: "Wash at 30° · Do not tumble dry · Do not iron the print",
  size_guide_title: "SIZE GUIDE",
  size_guide_col_size: "Size",
  size_guide_col_chest: "Chest (cm)",
  size_guide_col_length: "Length (cm)",
  size_guide_col_waist: "Waist (cm)",
  size_guide_disclaimer: "Indicative measurements. Tolerance ±1.5cm.",

  confirm_title: "ORDER CONFIRMED!",
  confirm_sub: "You will receive a confirmation email shortly.",
  confirm_syncing: "Syncing with Stripe…",
  confirm_order_no: "ORDER #",
  confirm_status: "Status",
  confirm_paid: "✓ PAID",
  confirm_processing: "⏳ PROCESSING",
  confirm_continue: "CONTINUE SHOPPING",
  confirm_to_academy: "GO TO ACADEMY",

  type_polo: "POLO",
  type_pantalon: "PANTS",
  type_camiseta: "TEE",
  type_polo_plural: "POLOS",
  type_pantalon_plural: "PANTS",
  type_camiseta_plural: "TEES",

  nav_shop: "Store",

  customize_cta: "CUSTOMIZE IN 3D",
  customize_eyebrow: "3D STUDIO",
  customize_title: "Design your one-of-a-kind piece",
  customize_sub: "Rotate, recolor, drop your logo or your name. Customization adds",
  customize_surcharge_label: "Customization +€15",
  customize_back: "Back to product",
  customize_section_color: "GARMENT COLOR",
  customize_section_text: "TEXT",
  customize_section_text_placeholder: "Your text (e.g. REBEL)",
  customize_section_text_color: "TEXT COLOR",
  customize_section_image: "LOGO OR IMAGE",
  customize_section_image_btn: "UPLOAD IMAGE",
  customize_section_image_clear: "Remove image",
  customize_section_image_hint: "PNG / JPG · max 5 MB",
  customize_section_size: "SIZE",
  customize_section_preview: "PREVIEW",
  customize_capture_btn: "GENERATE PREVIEW",
  customize_loading: "Loading 3D model…",
  customize_rotate_hint: "Drag to rotate · Scroll to zoom",
  customize_add_to_cart: "ADD CUSTOMIZED TO CART",
  customize_added: "CUSTOMIZED ADDED",
  customize_select_size_first: "Select a size first",
  customize_total_label: "Total with customization",
  customize_only_available: "Only available for polos and t-shirts",

  cart_customized: "CUSTOMIZED",
  cart_customization_extra: "Customization +€15",
};

const SK = {
  back_home: "Späť na REBELBTC",
  eyebrow: "SHADOW MARKET™",
  tagline: "INTERNÉ KOLEKCIE — LIMITOVANÁ EDÍCIA",
  drop_active: "● DROP AKTÍVNY — VOL.01",

  under_construction_title: "Obchod v rekonštrukcii",
  under_construction_body:
    "Dolaďujeme posledné detaily logistiky a produktovej fotografie. Obrázky sú provizórne. Objednávky otvoríme veľmi skoro — platobný systém je už pripravený na spustenie.",

  stat_polo: "POLO",
  stat_pantalon: "NOHAVICE",
  stat_camiseta: "TRIČKO",
  stat_pro: "PRO",

  tab_all: "VŠETKO",
  tab_polo: "POLOS",
  tab_pantalon: "NOHAVICE",
  tab_camiseta: "TRIČKÁ",

  card_size_label: "Veľkosť",
  card_add: "PRIDAŤ",
  card_added: "PRIDANÉ",
  card_quick_add: "PRIDAŤ DO KOŠÍKA",
  card_pro_label: "PRO",
  card_pro_hint: (price) => `€${price.toFixed(2)} PRO`,
  card_no_products: "V tejto kategórii nie sú produkty.",
  rbl_badge_discount: "-25% s R₿L",

  pro_upsell_eyebrow: "SI PRO?",
  pro_upsell_title_1: "Automatická",
  pro_upsell_title_2: "zľava na všetky produkty",
  pro_upsell_cta: "AKTIVOVAŤ PRO",

  open_cart: "Otvoriť košík",

  cart_title: "TVOJ KOŠÍK",
  cart_empty: "Tvoj košík je prázdny",
  cart_empty_cta: "PREZRIEŤ OBCHOD",
  cart_subtotal: "Medzisúčet",
  cart_discount: "PRO zľava (-15%)",
  cart_shipping: "Doprava",
  cart_free: "ZDARMA",
  cart_total: "SPOLU",
  cart_add_for_free_shipping: (delta) =>
    `Pridaj €${delta.toFixed(2)} a doprava je zdarma`,
  cart_checkout: "PREJSŤ NA PLATBU",
  cart_checkout_with_total: (total) =>
    `PREJSŤ NA PLATBU — €${total.toFixed(2)}`,
  cart_redirecting: "PRESMEROVANIE…",
  cart_secure: "BEZPEČNÁ PLATBA · STRIPE · DPH V CENE",
  cart_continue: "Pokračovať v nákupe",
  cart_summary: "SÚHRN",

  product_more_variants: "ĎALŠIE VARIANTY",
  product_color: "Farba",
  product_size: "Veľkosť",
  product_size_guide: "TABUĽKA VEĽKOSTÍ",
  product_quantity: "Kusy",
  product_add: "PRIDAŤ DO KOŠÍKA",
  product_added: "PRIDANÉ",
  product_activate_pro: "Aktivuj PRO pre -15% →",
  product_pro_price: "PRO CENA",
  product_not_found: "PRODUKT NENÁJDENÝ",
  product_back_store: "← SPÄŤ DO OBCHODU",
  acc_details: "MATERIÁLY A DETAILY",
  acc_shipping: "DORUČENIE A VRÁTENIE",
  acc_care: "STAROSTLIVOSŤ",
  shipping_std: (cost) => `Štandard 3-7 dní: €${cost.toFixed(2)}`,
  shipping_free_text: (min) => `Zdarma pri objednávkach nad €${min.toFixed(0)}`,
  shipping_returns: "Vrátenie: 14 dní",
  shipping_contact: "Kontakt: rebelbtc@rebelbtc.com",
  care_body: "Prať na 30° · Nesušiť v sušičke · Nežehliť potlač",
  size_guide_title: "TABUĽKA VEĽKOSTÍ",
  size_guide_col_size: "Veľkosť",
  size_guide_col_chest: "Hrudník (cm)",
  size_guide_col_length: "Dĺžka (cm)",
  size_guide_col_waist: "Pás (cm)",
  size_guide_disclaimer: "Orientačné rozmery. Tolerancia ±1.5cm.",

  confirm_title: "OBJEDNÁVKA POTVRDENÁ!",
  confirm_sub: "Čoskoro dostaneš potvrdzovací email.",
  confirm_syncing: "Synchronizácia so Stripe…",
  confirm_order_no: "OBJ. ČÍSLO",
  confirm_status: "Stav",
  confirm_paid: "✓ ZAPLATENÉ",
  confirm_processing: "⏳ SPRACOVANIE",
  confirm_continue: "POKRAČOVAŤ V NÁKUPE",
  confirm_to_academy: "DO AKADÉMIE",

  type_polo: "POLO",
  type_pantalon: "NOHAVICE",
  type_camiseta: "TRIČKO",
  type_polo_plural: "POLOS",
  type_pantalon_plural: "NOHAVICE",
  type_camiseta_plural: "TRIČKÁ",

  nav_shop: "Obchod",

  customize_cta: "PRISPÔSOBIŤ V 3D",
  customize_eyebrow: "3D ŠTÚDIO",
  customize_title: "Navrhni si svoj jedinečný kúsok",
  customize_sub: "Otáčaj, vyfarbuj, pridaj logo alebo svoje meno. Personalizácia stojí navyše",
  customize_surcharge_label: "Personalizácia +€15",
  customize_back: "Späť na produkt",
  customize_section_color: "FARBA ODEVU",
  customize_section_text: "TEXT",
  customize_section_text_placeholder: "Tvoj text (napr. REBEL)",
  customize_section_text_color: "FARBA TEXTU",
  customize_section_image: "LOGO ALEBO OBRÁZOK",
  customize_section_image_btn: "NAHRAŤ OBRÁZOK",
  customize_section_image_clear: "Odstrániť obrázok",
  customize_section_image_hint: "PNG / JPG · max 5 MB",
  customize_section_size: "VEĽKOSŤ",
  customize_section_preview: "NÁHĽAD",
  customize_capture_btn: "VYGENEROVAŤ NÁHĽAD",
  customize_loading: "Načítavam 3D model…",
  customize_rotate_hint: "Ťahaj pre rotáciu · Koliesko pre zoom",
  customize_add_to_cart: "PRIDAŤ PERSONALIZOVANÉ DO KOŠÍKA",
  customize_added: "PRIDANÉ",
  customize_select_size_first: "Najprv vyber veľkosť",
  customize_total_label: "Spolu s personalizáciou",
  customize_only_available: "Dostupné iba pre polos a tričká",

  cart_customized: "PERSONALIZOVANÉ",
  cart_customization_extra: "Personalizácia +€15",
};

const DE = {
  back_home: "Zurück zu REBELBTC",
  eyebrow: "SHADOW MARKET™",
  tagline: "INTERNE KOLLEKTIONEN — LIMITIERTE AUFLAGE",
  drop_active: "● AKTIVER DROP — VOL.01",
  under_construction_title: "Shop im Aufbau",
  under_construction_body: "Wir finalisieren die letzten Details zur Logistik und Produktfotografie. Die Bilder sind vorläufig. Bestellungen werden sehr bald möglich sein — das Zahlungssystem ist bereits für den Launch verbunden.",
  stat_polo: "POLO",
  stat_pantalon: "HOSE",
  stat_camiseta: "T-SHIRT",
  stat_pro: "PRO",
  tab_all: "ALLE",
  tab_polo: "POLOS",
  tab_pantalon: "HOSEN",
  tab_camiseta: "T-SHIRTS",
  card_size_label: "Größe",
  card_add: "HINZUFÜGEN",
  card_added: "HINZUGEFÜGT",
  card_quick_add: "IN DEN WARENKORB",
  card_pro_label: "PRO",
  card_no_products: "Keine Produkte in dieser Kategorie.",
  rbl_badge_discount: "-25% mit R₿L",
  pro_upsell_eyebrow: "BIST DU PRO?",
  pro_upsell_title_1: "Automatischer",
  pro_upsell_title_2: "Rabatt auf alle Produkte",
  pro_upsell_cta: "PRO AKTIVIEREN",
  open_cart: "Warenkorb ansehen",
  cart_title: "DEIN WARENKORB",
  cart_empty: "Dein Warenkorb ist leer",
  cart_empty_cta: "ZUM SHOP",
  cart_subtotal: "Zwischensumme",
  cart_discount: "PRO-Rabatt (-15%)",
  cart_shipping: "Versand",
  cart_free: "GRATIS",
  cart_total: "GESAMT",
  cart_checkout: "ZUR KASSE",
  cart_redirecting: "WEITERLEITUNG…",
  cart_secure: "SICHERE ZAHLUNG · STRIPE · INKL. MWST.",
  cart_continue: "Weiter einkaufen",
  cart_summary: "ZUSAMMENFASSUNG",
  product_more_variants: "WEITERE VARIANTEN",
  product_color: "Farbe",
  product_size: "Größe",
  product_size_guide: "GRÖẞENTABELLE",
  product_quantity: "Menge",
  product_add: "IN DEN WARENKORB",
  product_added: "HINZUGEFÜGT",
  product_activate_pro: "PRO aktivieren für -15% →",
  product_pro_price: "PRO PREIS",
  product_not_found: "PRODUKT NICHT GEFUNDEN",
  product_back_store: "← ZURÜCK ZUM SHOP",
  acc_details: "MATERIALIEN UND DETAILS",
  acc_shipping: "VERSAND UND RÜCKSENDUNGEN",
  acc_care: "PFLEGE",
  shipping_returns: "Rücksendungen: 14 Tage",
  shipping_contact: "Kontakt: rebelbtc@rebelbtc.com",
  care_body: "Bei 30° waschen · Nicht im Trockner trocknen · Logo nicht bügeln",
  size_guide_title: "GRÖẞENTABELLE",
  size_guide_col_size: "Größe",
  size_guide_col_chest: "Brust (cm)",
  size_guide_col_length: "Länge (cm)",
  size_guide_col_waist: "Taille (cm)",
  size_guide_disclaimer: "Richtwerte. Toleranz ±1,5 cm.",
  confirm_title: "BESTELLUNG BESTÄTIGT!",
  confirm_sub: "Du erhältst in Kürze eine Bestätigungs-E-Mail.",
  confirm_syncing: "Synchronisierung mit Stripe…",
  confirm_order_no: "BESTELLNR.",
  confirm_status: "Status",
  confirm_paid: "✓ BEZAHLT",
  confirm_processing: "⏳ IN BEARBEITUNG",
  confirm_continue: "WEITER EINKAUFEN",
  confirm_to_academy: "ZUR ACADEMY",
  type_polo: "POLO",
  type_pantalon: "HOSE",
  type_camiseta: "T-SHIRT",
  type_polo_plural: "POLOS",
  type_pantalon_plural: "HOSEN",
  type_camiseta_plural: "T-SHIRTS",
  nav_shop: "Shop",
  customize_cta: "IN 3D PERSONALISIEREN",
  customize_eyebrow: "3D-STUDIO",
  customize_title: "Gestalte dein einzigartiges Stück",
  customize_sub: "Drehen, Farbe anwenden, dein Logo hochladen oder deinen Namen anbringen. Die Personalisierung fügt hinzu",
  customize_surcharge_label: "Personalisierung +€15",
  customize_back: "Zurück zum Produkt",
  customize_section_color: "FARBE DES KLEIDUNGSSTÜCKS",
  customize_section_text: "TEXT",
  customize_section_text_placeholder: "Dein Text (z. B. REBEL)",
  customize_section_text_color: "TEXTFARBE",
  customize_section_image: "LOGO ODER BILD",
  customize_section_image_btn: "BILD HOCHLADEN",
  customize_section_image_clear: "Bild entfernen",
  customize_section_image_hint: "PNG / JPG · max. 5 MB",
  customize_section_size: "GRÖẞE",
  customize_section_preview: "VORSCHAU",
  customize_capture_btn: "VORSCHAU GENERIEREN",
  customize_loading: "3D-Modell wird geladen…",
  customize_rotate_hint: "Ziehen zum Drehen · Rollen zum Zoomen",
  customize_add_to_cart: "PERSONALISIERT IN DEN WARENKORB",
  customize_added: "PERSONALISIERT HINZUGEFÜGT",
  customize_select_size_first: "Wähle zuerst eine Größe",
  customize_total_label: "Gesamt mit Personalisierung",
  customize_only_available: "Nur für Polos und T-Shirts verfügbar",
  cart_customized: "PERSONALISIERT",
  cart_customization_extra: "Personalisierung +€15",
};

const ZH_CN = {
  back_home: "返回 REBELBTC",
  eyebrow: "SHADOW MARKET™",
  tagline: "内部系列 — 限量版",
  drop_active: "● 正在发售 — VOL.01",
  under_construction_title: "商店建设中",
  under_construction_body: "我们正在完成物流和产品摄影的最后细节。图片为临时性质。订单将很快开放 — 支付系统已为发布做好连接。",
  stat_polo: "POLO衫",
  stat_pantalon: "裤子",
  stat_camiseta: "T恤",
  stat_pro: "PRO",
  tab_all: "全部",
  tab_polo: "POLO衫",
  tab_pantalon: "裤子",
  tab_camiseta: "T恤",
  card_size_label: "尺码",
  card_add: "添加",
  card_added: "已添加",
  card_quick_add: "加入购物车",
  card_pro_label: "PRO",
  card_no_products: "此类别暂无产品。",
  rbl_badge_discount: "R₿L享-25%",
  pro_upsell_eyebrow: "你是PRO会员吗？",
  pro_upsell_title_1: "所有产品",
  pro_upsell_title_2: "自动折扣",
  pro_upsell_cta: "激活PRO",
  open_cart: "查看购物车",
  cart_title: "你的购物车",
  cart_empty: "你的购物车是空的",
  cart_empty_cta: "查看商店",
  cart_subtotal: "小计",
  cart_discount: "PRO折扣 (-15%)",
  cart_shipping: "运费",
  cart_free: "免费",
  cart_total: "总计",
  cart_checkout: "前往结账",
  cart_redirecting: "正在跳转…",
  cart_secure: "安全支付 · STRIPE · 含增值税",
  cart_continue: "继续购物",
  cart_summary: "订单摘要",
  product_more_variants: "更多款式",
  product_color: "颜色",
  product_size: "尺码",
  product_size_guide: "尺码指南",
  product_quantity: "数量",
  product_add: "加入购物车",
  product_added: "已添加",
  product_activate_pro: "激活PRO享-15% →",
  product_pro_price: "PRO价格",
  product_not_found: "产品未找到",
  product_back_store: "← 返回商店",
  acc_details: "材质与细节",
  acc_shipping: "运送与退货",
  acc_care: "保养说明",
  shipping_returns: "退货：14天",
  shipping_contact: "联系方式：rebelbtc@rebelbtc.com",
  care_body: "30°水洗 · 不可烘干 · 不可熨烫Logo",
  size_guide_title: "尺码指南",
  size_guide_col_size: "尺码",
  size_guide_col_chest: "胸围 (cm)",
  size_guide_col_length: "长度 (cm)",
  size_guide_col_waist: "腰围 (cm)",
  size_guide_disclaimer: "参考尺寸。误差±1.5cm。",
  confirm_title: "订单已确认！",
  confirm_sub: "你将很快收到确认邮件。",
  confirm_syncing: "正在与Stripe同步…",
  confirm_order_no: "订单号",
  confirm_status: "状态",
  confirm_paid: "✓ 已支付",
  confirm_processing: "⏳ 处理中",
  confirm_continue: "继续购物",
  confirm_to_academy: "前往学院",
  type_polo: "POLO衫",
  type_pantalon: "裤子",
  type_camiseta: "T恤",
  type_polo_plural: "POLO衫",
  type_pantalon_plural: "裤子",
  type_camiseta_plural: "T恤",
  nav_shop: "商店",
  customize_cta: "3D定制",
  customize_eyebrow: "3D工作室",
  customize_title: "设计你的独特单品",
  customize_sub: "旋转、应用颜色、上传Logo或添加你的名字。定制服务需额外支付",
  customize_surcharge_label: "定制 +€15",
  customize_back: "返回产品",
  customize_section_color: "服装颜色",
  customize_section_text: "文字",
  customize_section_text_placeholder: "你的文字 (例如 REBEL)",
  customize_section_text_color: "文字颜色",
  customize_section_image: "LOGO或图片",
  customize_section_image_btn: "上传图片",
  customize_section_image_clear: "移除图片",
  customize_section_image_hint: "PNG / JPG · 最大5 MB",
  customize_section_size: "尺码",
  customize_section_preview: "预览",
  customize_capture_btn: "生成预览",
  customize_loading: "正在加载3D模型…",
  customize_rotate_hint: "拖动旋转 · 滚轮缩放",
  customize_add_to_cart: "将定制品加入购物车",
  customize_added: "定制品已添加",
  customize_select_size_first: "请先选择尺码",
  customize_total_label: "含定制总价",
  customize_only_available: "仅适用于POLO衫和T恤",
  cart_customized: "已定制",
  cart_customization_extra: "定制 +€15",
};

const TABLE = { es: ES, en: EN, sk: SK, de: DE, "zh-CN": ZH_CN };

export const useShopI18n = (lang) => TABLE[lang] || TABLE.es;
export const getShopI18n = (lang) => TABLE[lang] || TABLE.es;

// Helper to fetch plural label from product type
export const typeLabelPlural = (lang, type) => {
  const t = getShopI18n(lang);
  return type === "polo"
    ? t.type_polo_plural
    : type === "pantalon"
    ? t.type_pantalon_plural
    : t.type_camiseta_plural;
};
export const typeLabelSingular = (lang, type) => {
  const t = getShopI18n(lang);
  return type === "polo"
    ? t.type_polo
    : type === "pantalon"
    ? t.type_pantalon
    : t.type_camiseta;
};
